import { type PropsWithChildren, type ReactNode, Suspense, useEffect } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { FallbackApplication } from './FallbackApplication'
import { useTranslationsHotReload } from './useTranslationsHotReload'

type DayJsLocalizationProps = PropsWithChildren

const DayJsLocalization = ({ children }: DayJsLocalizationProps) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    dayjs.locale(i18n.language)
  }, [i18n.language])

  return children
}

const TranslationsHotReload = () => {
  useTranslationsHotReload()

  return null
}

type I18nProviderProps = PropsWithChildren<{
  /**
   * While retrieving our i18n assets show your own custom loading page/component
   * for example the same while loading your application, so user doesnt see all kind of different spinners/skeletons
   */
  fallback?: ReactNode
}>

export const I18nProvider = ({ children, fallback = <FallbackApplication /> }: I18nProviderProps) => (
  <Suspense fallback={fallback}>
    <TranslationsHotReload />
    <DayJsLocalization>{children}</DayJsLocalization>
  </Suspense>
)
